import { alertConfirmar } from "./alerts";

export const compartirEnlace = () => {
    const url = window.location.href;
    const title = document.title || 'Mirá esta subasta en Adrian Mercado';
    const text = 'Te comparto este link, está buenísimo:';
  
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: text,
          url: url,
        })
        .then(() => alertConfirmar('Enlace compartido con éxito'))
        .catch((error) => console.log('Error al compartir', error));
    } else {
      copiarAlPortapapeles(url);
      alertConfirmar('Enlace copiado al portapapeles. Ahora podés compartirlo donde quieras.');
    }
  };
  
  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard.writeText(texto).then(() => {
      alertConfirmar('Texto copiado al portapapeles');
    });
  };
  